<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div style="padding-bottom: 10px; text-align: left">
      <span style="margin-right: 10px;">白名单</span>
      <el-button type="primary" size="mini" @click="getAdd">添加白名单</el-button>
      <el-input v-model="search.phone" placeholder="输入手机号" size="mini" @change="init" clearable
        style="width: 300px; margin:0 10px"></el-input>
      <el-button size="mini" @click="init">刷新</el-button>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="90%" v-loading="loading">
      <el-table-column prop="phone" label="手机号" min-width="180" align="center" sortable></el-table-column>
      <el-table-column prop="password" label="登录验证码" min-width="180" align="center" sortable></el-table-column>
      <el-table-column prop="remark" label="备注" min-width="180" align="center" sortable></el-table-column>
      <el-table-column prop="createUserName" label="创建人" min-width="180" align="center" sortable></el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="180" align="center" sortable></el-table-column>
      <el-table-column fixed="right" width="150" align="center" label="操作">
        <template #default="scope">
          <el-button type="primary" size="mini" @click="getUpdate(scope.row)">修改</el-button>
          <el-popconfirm title="确定删除该条单据吗？" style="margin-left: 10px" @confirm="getDelete(scope.row)">
            <template #reference>
              <el-button size="mini" type="danger">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="show" title="添加白名单" width="400px">
      <el-form ref="form" size="small" :model="formData" label-width="auto" label-position="right" :rules="rules">
        <el-form-item prop="phone" label="手机号">
          <el-input v-model="formData.phone" placeholder="请输入手机号" :disabled="isUpdate"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="登录验证码">
          <el-input v-model="formData.password" type="number" placeholder="请输入登录验证码"></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input v-model="formData.remark" placeholder="请输入备注" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <div style="text-align: center">
          <el-button type="primary" style="width: 100%" @click="save" :loading="saveLoading">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import XEUtils from 'xe-utils'
export default {
  name: 'platformAudit',
  data() {
    return {
      data: [],
      loading: false,
      search: {
        phone: ''
      },
      show: false,
      formData: {
        phone: '',
        remark: ''
      },
      saveLoading: false,
      rules: {
        phone: [{ required: true, trigger: 'change', message: '输入手机号' }],
        remark: [{ required: true, trigger: 'change', message: '输入备注' }],
        password: [
          { required: true, trigger: 'change', message: '输入登录验证码' },
          { min: 6, max: 6, trigger: 'change', message: '登录验证码长度为6' }
        ]
      },
      isUpdate: false
    }
  },
  mounted() {
    this.init()
    this.$validate.ToDocumentTitle()
  },
  methods: {
    init() {
      const params = {
        params: {}
      }
      for (let key in this.search) {
        if (this.search[key]) {
          params.params[key] = this.search[key]
        }
      }
      this.loading = true
      this.$axios.get('/account/user/white/list', params).then(res => {
        this.data = XEUtils.orderBy(res.data.data, [['id', 'desc']])
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getAdd() {
      this.show = true
      this.isUpdate = false
      this.formData = {
        phone: '',
        remark: '',
        password: ''
      }
    },
    getUpdate(row) {
      this.show = true
      this.isUpdate = true
      this.formData = JSON.parse(JSON.stringify(row))
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saveLoading = true
          const params = {
            id: this.formData.id || undefined,
            phone: this.formData.phone,
            password: this.formData.password,
            remark: this.formData.remark
          }
          this.$axios.post('/account/user/white/update', params).then(() => {
            this.$message.success(`${this.isUpdate ? '修改' : '添加'} 白名单成功`)
            this.show = false
            this.saveLoading = false
            this.init()
          }).catch(err => {
            console.log(`添加白名单失败`, err)
            this.saveLoading = false
          })
        } else {
          return false
        }
      })
    },
    getDelete(row) {
      const params = {
        id: row.id,
        del: true
      }
      this.$axios.post('/account/user/white/update', params).then(() => {
        this.$message.success(`删除成功`)
        this.init()
      }).catch(err => {
        console.log(`删除失败`, err)
      })
    }
  }

}
</script>
